import React, { Component } from "react";
import Images from "../../Images";
import { connect } from "react-redux";
import { removeDisabledSportTypes , setSport } from "../../../../redux/actions/sportTypesActions";
import { loadSportCategories } from "../../../../redux/actions/categoriesActions";
import { changeFeed } from "../../../../redux/actions/appActions";

export class SportCategories extends Component {
  onSportTypeClick = (item) => {
    const {
      history,
      setSport,
      loadSportCategories,
      removeDisabledSportTypes,
      changeFeed
    } = this.props;

      history.push(
        `/sport/6/${item.sport.sportId}/${item.sport.sportDisplayName.toLowerCase()}`
      );
    

    setSport(item);
    removeDisabledSportTypes();
    changeFeed('6','sport')

    const request = {
      Data: {
        Feed: { FeedId: 6 },
        Sport: { SportId: 1 },
      },
    };
    loadSportCategories(request);
  };

  onSportClick(sport) {
    this.onSportTypeClick(sport);
  }

  render() {
    const { sportName, sportColor, sportImage , sport } = this.props;
    return (
      <div className="sport-categories-slide">
        <div className="sport-category" onClick={() => this.onSportClick(sport)}>
          <img src={sportImage} />
          <span style={{ color: `${sportColor}` }}>{sportName}</span>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connected: state.signalr.connected,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loadSportCategories: (request) => {
      dispatch(loadSportCategories(request));
    },
    setSport: (item) => {
      dispatch(setSport(item));
    },
    removeDisabledSportTypes: () => {
      dispatch(removeDisabledSportTypes());
    },
    changeFeed: (feedId, feedName) => dispatch(changeFeed(feedId, feedName)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportCategories);
